var impressum = "Notificación legal";
var privacy = "Privacidad y legal";
var recallInfo = "Información de llamada a revisión";
var signOut = "Cerrar sesión";
var es_mx = {
	impressum: impressum,
	privacy: privacy,
	recallInfo: recallInfo,
	signOut: signOut
};

export { es_mx as default, impressum, privacy, recallInfo, signOut };
